<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openItemModal">
      <i class="fas fa-plus"></i> Thêm
    </button>
    <b-table bordered head-variant="dark" hover responsive :fields="fields" :items="items" table-variant="light">
      <template v-slot:cell(action)="data">
        <button class="btn btn-info mr-2" @click="openUpdateItemModal(data)">
          <i class="fas fa-eye"></i>
        </button>
        <button class="btn btn-danger" @click="deleteItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      @ok="storeItem"
    >
      <template v-slot:modal-title>
        <div v-if="item_selected.id <= 0">Thêm thông tin kỹ năng</div>
        <div v-else>Cập nhật thông tin kỹ năng</div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button v-if="item_selected.id <= 0" variant="success" @click="ok()">Thêm</b-button>
        <b-button v-else variant="success" @click="ok()">Cập nhật</b-button>
        <b-button variant="danger" @click="cancel()">Đóng</b-button>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">                
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Tên kỹ năng</label>
            <code>*</code>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.tenkynang" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Ghi chú</label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea v-model="item_selected.ghichu" rows="2"></b-form-textarea>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "EmployeeSkill",
  props: ["item"],
  data() {
    return {
      modalShow: false,
      items: [],
      itemIdex: null,
      fields: [        
        {
          key: "tenkynang",
          label: "Tên kỹ năng",
        },
        {
          key: "ghichu",
          label: "Ghi chú",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "150px !important" },
        },
      ],
      item_null: {
        id: 0,
        employeeid: 0,
        tenkynang: null,
        ghichu: null,
      },
      item_selected: {
        id: 0,
        employeeid: 0,
        tenkynang: null,
        ghichu: null,
      },
    };
  },
  created() {
    if (this.item != null) this.initData();
  },
  methods: {
    initData() {
      axios
        .get(`/api/employeeskill/${this.item.id}`)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    openItemModal() {
      this.item_selected = JSON.parse(JSON.stringify(this.item_null));
      this.item_selected.employeeid = this.item.id;
      this.modalShow = true;
    },
    openUpdateItemModal(data) {
      this.item_selected = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;
    },
    storeItem(bvModalEvt) {
      if (
        !(
          this.item_selected.tenkynang &&
          this.item_selected.tenkynang.length
        )
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.item_selected.id <= 0) {
          axios
            .post("/api/employeeskill", this.item_selected)
            .then((res) => {
              this.modalShow = false;
              this.items.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        } else {
          axios
            .put("/api/employeeskill", this.item_selected)
            .then((res) => {
              this.modalShow = false;
              this.items[this.itemIdex] = JSON.parse(
                JSON.stringify(this.item_selected)
              );
              const temp = JSON.parse(JSON.stringify(this.items));
              this.items = JSON.parse(JSON.stringify(temp));
              this.itemIdex = null;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/employeeskill/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>